import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const DeviceDetails = styled(TextLayoutComponent)`
  padding: 10px;
`;
